import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./about.scss";

export const About = () => {
  React.useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);
return (
  <section>
    <div className="container about" id="about">
      <div className="row">
        <div className="about-header" data-aos="fade-up">
          <h1>/About Me</h1>
        </div>
      </div>
      <div className="row about-description" data-aos="fade-up">
        <p>
          I have experience working at multinational companies such as&nbsp;
          <a className="work-link" href="https://embraer.com/br/pt">
            Embraer
          </a>
          &nbsp;and&nbsp;
          <a className="work-link" href="https://www.jnj.com/">
            Johnson & Johnson
          </a>
          <a>. </a>
            In these roles, I contributed to high-complexity projects and collaborated with global teams.  
            I value clear, systematic, and pragmatic approaches to problem-solving, always grounded in business needs.  
            My focus is on developing efficient, data-driven solutions that create real impact.
        </p>
      </div>
      <div className="row about-description">
        <p data-aos="fade-up">
          I have experience with the following technologies and skills:
        </p>
      </div>
      <ul className="skills">
        <li className="custom-list-item" data-aos="fade-up">Python</li>
        <li className="custom-list-item" data-aos="fade-up">SQL</li>
        <li className="custom-list-item" data-aos="fade-up">R</li>
        <li className="custom-list-item" data-aos="fade-up">Machine Learning</li>
        <li className="custom-list-item" data-aos="fade-up">Power BI</li>
        <li className="custom-list-item" data-aos="fade-up">Statistics</li>
        <li className="custom-list-item" data-aos="fade-up">Databricks</li>
        <li className="custom-list-item" data-aos="fade-up">AWS</li>
        <li className="custom-list-item" data-aos="fade-up">Pipelines Kedro</li>
        <li className="custom-list-item" data-aos="fade-up">APIs</li>
        <li className="custom-list-item" data-aos="fade-up">Git / GitHub</li>
      </ul>
    </div>
  </section>
); };

export default About;
